import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
class LogoAnimation {
    constructor() {
        gsap.registerPlugin(ScrollTrigger);
        this.logo = document.querySelector('.nav.logo-animation .nav__logo svg');
        this.lockupdiv = document.querySelector('.home-lockup');
        this.lockup = document.querySelector('.home-lockup .home-lockup__intro');
        this.layout = document.querySelector('.layout');
        this.nav = document.querySelector('.nav');
        this.viewportHeight = window.innerHeight;
        this.layoutMargin = parseInt(window.getComputedStyle(this.layout).marginBottom);

        this.breakPointDims = {
            320: {
                scale: 0.3477,
                translateY: this.calcTy(window.innerWidth) + "px",
                lockupDiv: 150,
                yPercent: this.calcYPercent(window.innerWidth)
            },
            480: {
                scale: 0.3477,
                translateY: "-333px",
                lockupDiv: 100,
                yPercent: 30
            },
            800: {
                scale: 0.25,
                translateY: "-594px",
                lockupDiv: 70,
                yPercent: 20
            },
            1030: {
                scale: 0.24,
                translateY: "-516px",
                lockupDiv: 165,
                yPercent: 47
            },
            1200: {
                scale: 0.2827,
                translateY: "-575px",
                lockupDiv: 180,
                yPercent: 47
            },
            1440: {
                scale: 0.2353,
                translateY: "-595px",
                lockupDiv: 180,
                yPercent: 47
            }
        };

        this.resize();
        this.selectWidth();
    }

    resize() {
        window.addEventListener('resize', () => {
            if(this.viewportHeight !== window.innerHeight) {
                this.viewportHeight = window.innerHeight;
            } else {
                this.selectWidth();
            }
        });
    }

    selectWidth() {
        const bpArray = Object.keys(this.breakPointDims);
        let dims;
        bpArray.forEach((value) => {
            this.mediaQuery = window.matchMedia(`(min-width: ${value}px)`);
            if(this.mediaQuery.matches) {
                dims = this.breakPointDims[value];
            }
        });
        this.logoAnim && this.logoAnim.time(0) && this.logoAnim.kill();
        this.navAnim && this.navAnim.time(0) && this.navAnim.kill();
        this.lockupAnim && this.lockupAnim.time(0) && this.lockupAnim.kill();
        this.layout.style.marginBottom = `${this.layoutMargin - dims.lockupDiv}px`;
        this.animate(dims);
    }

    animate(dims) {
        // logo animation
        gsap.to(this.logo, {
            scrollTrigger: {
                trigger: this.lockupdiv,
                start: "top 24px",
                end: "+380px",
                scrub: true,
            },
            scale: dims.scale,
            translateX: 0,
            translateY: dims.translateY,
            reversed: true,
            ease: "power1.out"
        });

        // main video banner position
        gsap.to('main.home', {
            scrollTrigger: {
                trigger: this.lockupdiv,
                start: "top top",
                end: "+440px -40px",
                scrub: true,
            },
            y: `${dims.lockupDiv}px`,
        });

        // lockup animation
        gsap.to(this.lockup, {
            scrollTrigger: {
                trigger: this.lockupdiv,
                start: "top top",
                end: "+440px -40px",
                scrub: true,
            },
            y: `${dims.lockupDiv}px`,
        });

        // Nav animation
        gsap.to(this.nav, {
            scrollTrigger: {
                trigger: this.lockupdiv,
                start: "+340px",
                end: "+440px -120px",
                scrub: true,
            },
            translateY: '-100px',
        });
    }

    calcTy(screenWidth) {
        // Weird calculation but it seems to work
        // Based on font size calculation and trial & error to get the right value
        // return (150 + 230 * (screenWidth - 320) / 576) - 327;
        return -180 + 0 * (screenWidth - 320) / 576;
    }

    calcYPercent(screenWidth) {
        return 55 + 0 * (screenWidth - 320) / 576;
    }
}

export default LogoAnimation;
